export default "__VITE_ASSET__99dfc976__"